/**
 * Static reader shell for the AI Create submission dialog opened from a
 * completed topic card. Deliberately mirrors communityIdeaDetailModalMarkup
 * (same .community-detail-modal classes, close control, Close footer) so the
 * two readers behave identically; the section renderer owns the content
 * differences (learning brief instead of votes).
 */
export const aiSubmissionDetailModalMarkup = String.raw`<div class="modal-overlay" id="aiSubmissionDetailModal" hidden>
  <div class="modal community-detail-modal" role="dialog" aria-modal="true" aria-labelledby="aiSubmissionDetailDialogTitle">
    <button type="button" class="modal-close modal-close--floating" data-proto-click="closeAiSubmissionDialog()" aria-label="Close submission dialog"><svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
    <div class="modal-body community-detail-host" data-ai-submission-detail-host></div>
    <footer class="community-detail-dialog-footer"><button type="button" class="btn btn-outline btn-lg" data-proto-click="closeAiSubmissionDialog()">Close</button></footer>
  </div>
</div>`;
